import { DeleteOutlined } from "@ant-design/icons";
import { Space, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDateTime } from "utils/formatter";
import dayjs from "dayjs"
const EmployeeWorkInWorkInLocationTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  selectedRowKeys = [],
  onChange = () => { },
  onDelete = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm:ss" : `DD/MM/${date.year() + 543} HH:mm`);
  }
  // console.log('updateBy', record?.createBy);
  const columns = [
    {
      title: <div className="text-table">{t("employee.work_in_location.label.workInLocationName")}</div>,
      dataIndex: "workInLocationName",
      key: "workInLocationName",
    },
    {
      title: (
        <div className="text-table">
          {t("workin_location.label.description")}
        </div>
      ),
      dataIndex: "description",
      key: "description",
      render: (_, record) => {
        const dataList = i18n.language === 'en' ? [
          record?.locationCoordinates
            ? `Location: ${record?.locationCoordinates}`
            : "",
          record?.radius ? `Radius: ${record?.radius}` : "",
          record?.deviceName ? `Device Name: ${record?.deviceName}` : "",
          record?.deviceId ? `Device Id: ${record?.deviceId}` : "",
          record?.serialNumber ? `Serial Number: ${record?.serialNumber}` : "",
        ] : [
          record?.locationCoordinates
            ? `สถานที่: ${record?.locationCoordinates}`
            : "",
          record?.radius ? `รัศมี: ${record?.radius}` : "",
          record?.deviceName ? `ชื่ออุปกรณ์: ${record?.deviceName}` : "",
          record?.deviceId ? `รหัสอุปกรณ์: ${record?.deviceId}` : "",
          record?.serialNumber ? `หมายเลขอุปกรณ์: ${record?.serialNumber}` : "",
        ];
        const formatList = dataList
          .filter((d) => d !== "")
          .map((d, idx) => {
            if (idx === 0) return <>{d}</>;
            return (
              <>
                <br />
                {d}
              </>
            );
          });
        return formatList;
      },
    },
    // {
    //   title: <div className="text-table">{t("employee.work_in_location.label.last_attendance_time")}</div>,
    //   dataIndex: "lastAttendanceTime",
    //   key: "lastAttendanceTime",
    //   sorter: true,
    //   render: (_, record) => {
    //     console.log('fook', record);

    //     const { lastModified = {} } = record;
    //     console.log('fook', lastModified);
    //     const name =
    //       i18n.language === "en" && lastModified?.nameEn
    //         ? lastModified?.nameEn + " " + lastModified?.surNameEn
    //         : lastModified?.name + " " + lastModified?.surName;
    //     if (record?.updateBy?.nameEn !== null) {
    //       return (
    //         <>
    //           {i18n.language === 'en' ? record?.updateBy?.nameEn + " " + record?.updateBy?.surNameEn : record?.updateBy?.name + " " + record?.updateBy?.surName}
    //           <br />
    //           {formatDate(record?.updateDate)}
    //         </>
    //       )
    //     } else {
    //       return (
    //         <>
    //           {i18n.language === 'en' ? record?.createBy?.nameEn + " " + record?.createBy?.surNameEn : record?.createBy?.name + " " + record?.createBy?.surName}
    //           <br />
    //           {formatDate(record?.createDate)}
    //         </>
    //       )
    //     }
    //   },
    // },
    roles.includes("DELETE_EMPLOYEE|WORK_IN|WORK_IN_LOCATION") ? {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <DeleteOutlined
            style={{ fontSize: "18px", color: "gray" }}
            onClick={() => {
              onDelete(record);
            }}
          />
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      rowKey={(record) => record?.id}
      onChange={onChange}
    // rowSelection={{
    //   type: "checkbox",
    //   selectedRowKeys,
    //   onChange: (values) => {
    //     onChange(values);
    //   },
    //   getCheckboxProps: (record) => {
    //     return { value: record?.value };
    //   },
    // }}
    />
  );
};

export default EmployeeWorkInWorkInLocationTable;
